<template>
  <div id="order">
    <header class="sub-page-nav has-text-centered">
      <back-arrow></back-arrow>
      <h1 class="is-cs-3 has-text-weight-bold">{{ page.title }}</h1>
    </header>
    <div class="wrapper">
      <div class="order-amount has-text-centered">
        <small class="is-cs-5">担当：{{ person.nickname }}</small>
        <div class="is-cs-4">
          <span class="has-text-weight-bold">合計</span>
          <span><em>{{ totalAmount.toLocaleString() }}</em>円</span>
        </div>
      </div>
      <h1 class="is-cs-3 is-c-text has-text-centered has-text-weight-bold" v-if="!saleId">
        読み込まれたウィッシュリスト
      </h1>
      <div class="item-list-tile item-list">
        <cachalog-item-list v-for="(item, index) in orderItems" v-if="item.quantity > 0"
          :item="item" :index="index" :parent="'order'" :wishlist="order" :key="index"
          :class="{sales: saleId, 'sold-out-order': item.sold_out && !saleId}"></cachalog-item-list>
      </div>
      <div v-if="page.id" class="has-text-centered">
        <button class="button is-rounded is-c-primary is-cs-4 is-large" v-if="wishlistId && !order.accounted" @click="complete">お会計を終わる</button>
        <button disabled class="button is-rounded is-cs-4 is-large" v-else-if="wishlistId">お会計済み</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mixin, indexOf } from './common.js'
import backArrow from './design/back-arrow.vue'
export default {
  components: {
    'back-arrow': backArrow
  },
  mixins: [mixin],
  props: ['pageId', 'wishlistId', 'saleId'],
  computed: {
    ...Vuex.mapState({
      user: 'user',
      users: 'users',
      page: 'page',
      _order: 'order',
      sales: 'sales'
    }),
    person () {
      if (this.$route.matched.some(route => route.name === 'order')) {
        return this.user
      } else {
        return this.users[this.order.users_ref.id] || {nickname: ''}
      }
    },
    pageTitle () {
      return this.page.title || ''
    },
    orderId () {
      return this.wishlistId || this.saleId
    },
    order () {
      return this.wishlistId ? this._order : this.sales[this.pageId].histories[this.saleId]
    },
    orderItems () {
      if (!this.order.items || !this.page.items.length) {
        return []
      }
      return this.order.items.map((item) => {
        const index = indexOf(this.page.items, 'id', item.id)
        return Object.assign({}, {
          ...this.page.items[index],
          quantity: item.quantity,
          orderPrice: item.price
        })
      })
    },
    totalAmount () {
      const total = this.page.items.reduce((a, b, i) => {
        const item = this.orderItems[i] || {quantity: 0}
        const price = (item.orderPrice ? item.orderPrice.value : b.price.value) || 0
        return a + price * item.quantity
      }, 0)
      return total
    }
  },
  methods: {
    complete () {
      if (confirm('お会計を終了します。よろしいですか？')) {
        this.$store.dispatch('completeOrder', this.order)
      }
    }
  },
  mounted () {
    /*
     * pageが遅れて読み込まれるためtransitionの実行に間に合わないのでcreatedじゃなくてmounted
     * そして.noneを追加
     */
    if (this.page.id) {
      this.$store.dispatch('fetchWishlist', this.orderId)
    } else if (!this.page.id && this.wishlistId) {
      this.$store.dispatch('fetchWishlistWithPage', this.orderId)
      document.querySelector('.main-page').classList.add('none')
    }
  },
  destroyed () {
    this.$store.commit('discardOrder')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order.vue